import { CloseIcon } from '@assets/icons'
import { IconButton } from '@mui/material'
import { styled } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import React from 'react'

const StyledSnackbarProvider = styled(SnackbarProvider)`
	&.SnackbarItem-contentRoot {
		color: #121212;
		font-size: 0.875rem;
		line-height: 1rem;
		border-radius: 12px;
	}
	&.SnackbarItem-variantSuccess {
		background-color: #44c571;
	}
	&.SnackbarItem-variantError {
		background-color: #e20909;
	}
	&.MuiButtonBase-root {
		svg path {
			fill: #393939;
		}
	}
`

const StyledIconButton = styled(IconButton)`
	&.MuiButtonBase-root {
		margin-top: 0px;
	}

	svg path {
		fill: #393939;
	}
`

interface IProps {
	children: React.ReactNode
}

const ToastProvider = ({ children }: IProps) => {
	const notistackRef = React.useRef<SnackbarProvider>(null)

	return (
		<StyledSnackbarProvider
			ref={notistackRef}
			hideIconVariant
			preventDuplicate
			maxSnack={3}
			autoHideDuration={5000}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
			action={key => (
				<StyledIconButton
					className="close-button"
					onClick={() => notistackRef?.current?.closeSnackbar(key)}
					size="large"
				>
					<CloseIcon />
				</StyledIconButton>
			)}
		>
			{children}
		</StyledSnackbarProvider>
	)
}

export default ToastProvider
